<script>
import AdminLayout from '@layouts/admin-main'
import AffiliateLogList from '@components/admin/affiliate-log-list'

export default {
  page: {
    title: 'Admin::AffiliateLogList',
    meta: [{ name: 'description', content: 'Admin::AffiliateLogList' }],
  },
  components: { AdminLayout, AffiliateLogList },
}
</script>

<template>
  <AdminLayout>
    <AffiliateLogList></AffiliateLogList>
  </AdminLayout>
</template>

<style lang="scss" module>
@import '@design';
</style>
